import React from 'react';
import Styles from '../components/Problemas.module.css';
const Problemas = () => {
  return (
    <div>
   
    </div>
  );
};

export default Problemas;
